import { render, staticRenderFns } from "./product-filters.vue?vue&type=template&id=6e1bbe1e&scoped=true"
import script from "./product-filters.vue?vue&type=script&lang=js"
export * from "./product-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1bbe1e",
  null
  
)

export default component.exports